<script setup lang="ts">
import type { Image, PortableTextBlock } from '@sanity/types';
import { computed, type Component } from 'vue';
import { VideoType } from '@pkg/sanity-utils/constants/video';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    anchorId?: string;
    mediaType: 'image' | 'video';
    image?: Image;
    parallax?: boolean;
    video?: {
      url?: string;
      webm?: string;
      ogg?: string;
      fallbackImage?: Image; 
      controls: boolean;
      autoplay: boolean;
      videoType?: VideoType;
    };
  };
  config: {
    innerComponent?: Component;
  },
}>();

const data = computed(() => ({
  mediaType: props.block?.mediaType,
  image: props.block?.image,
  parallax: props.block?.parallax ?? false,
  video: props.block?.video,
}));

</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data"/>
</template>
